import styled, { css, keyframes } from 'styled-components';
import {GlobalColors, GlobalFonts} from '../../globals';

export const ContButton = styled.div`
  
  text-align: center;
  align-items: center;
  

  &:active{
    background: ${GlobalColors.colorSecondary};
  }
`

const expandAnimation = keyframes`
  0% {
    width: 3rem;
  }
  50% {
    width: 100%;
  }
  100% {
    width: 3rem;
  }
`;

export const CfgBtnLink = css`
  position: relative;
  outline: none;
  padding: 0 0 0 0 !important;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: none;

  /* Display & Box Model */
  display: flex;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  
  /* Typografhy */
  text-decoration: none;
  font: 15px ${GlobalFonts.fontBold};
  color: ${props => props.theme === 'primary' ? GlobalColors.colorBtnTextPrimary : GlobalColors.colorBtnTextSecondary};
  cursor: pointer;
  
  z-index: 1;
  
  &:hover {
    font: 15px ${GlobalFonts.fontBold};
    color: ${props => props.theme === 'primary' ?  GlobalColors.colorBtnTextPrimary : GlobalColors.colorBtnTextSecondary};
  }
  
   &:hover div {
    width: 105%; /* Ancho del 100% al hacer hover */
    transition: width 0.3s;
  }

  //&:hover div {
  //  /* estilos al hacer hover */
  //  animation: ${expandAnimation} 2s infinite;
  //}

  &:hover button {
    width: 3rem;
    transition: width 0.5s;
    transition-delay: 0.5s;
  }

  &[aria-current]{
    color: ${props => props.color};
  }
  
  @media(min-width: 300px) and (max-width: 767px){
    
  }
  @media(min-width: 768px) and (max-width: 1023px){
    
  }
  @media(min-width: 1024px) and (max-width: 1215px){
    padding: 10px;
  }
  @media(min-width: 1216px) and (max-width: 1407px){
    padding: 10px;
  }
  @media(min-width: 1408px) and (max-width: 1919px){
    padding: 15px;
  }
  @media(min-width: 1920px){
    padding: 15px;
  }
`
export const Btn = styled.button`
  ${CfgBtnLink}
`
export const BtnAnchor = styled.a`
  //padding: 0 !important;
  ${CfgBtnLink}
`

export const ButtonAnchorBtn = styled.button`
  color: inherit;
`;

export const ButtonAnchor = styled.a`
  text-decoration: none;
  color: inherit;
`;

export const StyledCTA = styled.div`
  position: relative;
  margin: auto;
  padding: 19px 22px;
  transition: all 0.2s ease;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    border-radius: 28px;
    background: #CEE1F8;
    width: 56px;
    height: 56px;
    transition: all 0.3s ease;
    opacity: ${ props => props.theme === 'primary' ? 'none' : props.theme === 'secondary' ? '0.2' : '0.2'}
  }

  span {
    position: relative;
    text-decoration: none;
    font: 15px ${GlobalFonts.fontBold};
    color: ${props => props.theme === 'primary' ? GlobalColors.colorBtnTextPrimary : GlobalColors.colorBtnTextSecondary};
    cursor: pointer;
    vertical-align: initial;
  }

  svg {
    position: relative;
    top: 0;
    margin-left: 10px;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke: ${props => props.theme === 'primary' ?  GlobalColors.colorBtnTextPrimary : GlobalColors.colorBtnTextSecondary};
    stroke-width: 2;
    transform: translateX(-5px);
    transition: all 0.3s ease;
  }

  &:hover {
    &:before {
      width: 100%;
      background: #9BC3F3;
    }

    svg {
      transform: translateX(0);
    }
  }

  &:active {
    transform: scale(0.96);
  }
`;

export const BtnText = styled.span`
  padding-left: 10px;
  width: 100%;
`
export const BtnCircle = styled.div`
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  vertical-align: middle;
  position: absolute;
  z-index: -1;
  display: block;
  padding: 0 0 10px 0 !important;
  margin: 0 0 0px 0 !important;
  width: 3rem;
  height: 2.5rem;
  opacity: ${ props => props.theme === 'primary' ? 'none' : props.theme === 'secondary' ? '0.2' : '0.2'
  };
  background-color: ${
    props => props.theme === 'primary'
        ? GlobalColors.colorBtnCirclePrimary
        : props.theme === 'secondary'
            ? GlobalColors.colorBtnCircleSecondary
            : GlobalColors.colorBtnCircleTertiary
  };
  border-radius: 1.625rem;
  @include transition(all, 0.65s, cubic-bezier(0.65, 0, 0.076, 1));

`
export const BtnCircle2 = styled.button`
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  vertical-align: middle;
  position: absolute;
  z-index: -1;
  display: block;
  padding: 0 0 10px 0 !important;
  margin: 0 0 0px 0 !important;
  width: 100%;
  height: 2.5rem;
  opacity: ${ props => props.theme === 'primary' ? 'none' : props.theme === 'secondary' ? '0.2' : '0.2'
  };
  background-color: ${
    props => props.theme === 'primary'
        ? GlobalColors.colorBtnCirclePrimary
        : props.theme === 'secondary'
            ? GlobalColors.colorBtnCircleSecondary
            : GlobalColors.colorBtnCircleTertiary
  };
  border-radius: 1.625rem;
  @include transition(all, 0.65s, cubic-bezier(0.65, 0, 0.076, 1));
  border: none;
`

